!function(t) {
    var e = {};

    function r(n) {
        if (e[n]) return e[n].exports;
        var o = e[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports
    }
    r.m = t, r.c = e, r.d = function(t, e, n) {
        r.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
        })
    }, r.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }, r.t = function(t, e) {
        if (1 & e && (t = r(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t)
            for (var o in t) r.d(n, o, function(e) {
                return t[e]
            }.bind(null, o));
        return n
    }, r.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default
        } : function() {
            return t
        };
        return r.d(e, "a", e), e
    }, r.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, r.p = "", r(r.s = 0)
}([function(t, e, r) {
    t.exports = r(1)
}, function(t, e, r) {
    "use strict";

    function n(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1e4;
        return new Promise((function(r) {
            var n = setInterval((function() {
                t() && (r(t()), clearInterval(n), n = null)
            }), 50);
            setTimeout((function() {
                null !== n && (clearInterval(n), console.log("condition false"))
            }), e)
        }))
    }
        function setupPT416ToggleSwitches(popupContainer) {
          if (!popupContainer) return;
          
          const oneTimeToggle = popupContainer.querySelector('.pt_416_toggle_input_one_time');
          const subscriptionToggle = popupContainer.querySelector('.pt_416_toggle_input_subscription');
          const oneTimeWrapper = popupContainer.querySelector('.pt_416_onetime_wrapper');
          const subscriptionWrapper = popupContainer.querySelector('.pt_416_subscription_wrapper');
          const priceDisplay = popupContainer.querySelector('.pt_413_subscription_left_green_price');
          const priceDisplaySub = popupContainer.querySelector('.pt_413_subscription_left_green_price');
          const oneTimeRadioWrapper = popupContainer.querySelector('.pt396_one_time_radio_wrapper');
          const subscriptionRadioWrapper = popupContainer.querySelector('.pt396_subscription_radio_wrapper');
          const priceOnetime = popupContainer.querySelector('.pt396_one_time_real_price');
          const priceDisplayOne = popupContainer.querySelector('.pt_413_subscription_left_normal_price');
          const priceSubscription = popupContainer.querySelector('.pt396_subscription_radio_real_price');
          const priceDisplaySubs = popupContainer.querySelector('.pt_413_subscription_left_green_price');
          const priceDisplayOneBox = popupContainer.querySelector('.pt_416_onetime_left_price');
          const SunscriptionDiscoutnHeading = popupContainer.querySelector('.pt396_subscription_radio_heading');
          const SubsDiscoutnHeading = popupContainer.querySelector('.pt_416_subscription_left_heading');
          if (priceOnetime) priceDisplayOne.textContent = priceOnetime.textContent;
          if (priceSubscription) priceDisplaySubs.textContent = priceSubscription.textContent;
          if (priceOnetime) priceDisplayOneBox.textContent = priceOnetime.textContent;
          if (SunscriptionDiscoutnHeading) SubsDiscoutnHeading.textContent = SunscriptionDiscoutnHeading.textContent;
          
          if (oneTimeToggle) {
              oneTimeToggle.addEventListener('click', function () {
                  if (oneTimeWrapper && subscriptionWrapper && priceDisplay) {
                      oneTimeWrapper.classList.add('pt_416_hidden');
                      subscriptionWrapper.classList.remove('pt_416_hidden');
                  }
                if (subscriptionRadioWrapper) subscriptionRadioWrapper.click();
                 
              });
          }
          if (subscriptionToggle) {
              subscriptionToggle.addEventListener('click', function () {
                  if (oneTimeWrapper && subscriptionWrapper && priceDisplay) {
                      subscriptionWrapper.classList.add('pt_416_hidden');
                      oneTimeWrapper.classList.remove('pt_416_hidden');
                  }
                 if (oneTimeRadioWrapper) oneTimeRadioWrapper.click();
              });
          }
      }

    r.r(e);
    var o = {
            subCollections: "body.template-collection",
            productItem: ".CollectionMain .ProductList .ProductItem",
            productWrapperRating: ".Product__Wrapper .ProductItem__Rating",
            productItemAddToCartBtn: ".ProductItem .ProductItem_AddToCartBtn .Button--secondary",
            productGalleryCarouselImage: ".Product__Gallery .Product__Slideshow.Carousel .AspectRatio--withFallback > img"
        },
        i = {
            productPopupWrapper: "\n        <div class='pt396_popupWrapper'>\n        <div class='pt396_popupOverlay'></div>\n        <div class='pt396_popupContainer'>\n        <div class='pt396_closePopup'>\n        <div class='pt396_closePopup_btn'><img src='https://cdn.shopify.com/s/files/1/2135/4367/files/image_2_1_92c1ab40-9b91-4d91-86ec-abada9b0b233.png?v=1739164204'/></div>\n        </div>\n        </div></div>",
            productPopup:'<div class=\'pt396_popup\'><div class=\'pt396_imageContainer\'></div><div class=\'pt396_productDetailContainer\'><p class=\'pt396_productName\'></p><div class=\'pt396_reviewSection\'></div><div class=\'pt396_productBenefitsContainer\'></div><div class=\'pt396_subscription_wrapper pt_396_hide pt_396_subscriptionOption_not_available\'><div class="pt396_one_time_radio_wrapper pt396_radio_block"><span class="pt396_one_time_heading pt396_radio_heading">One-time purchase</span><span class="pt396_one_time_real_price">$68</span><p class="pt396_one_time_guarantee_text">No Subscription</p></div><div class="pt396_subscription_radio_wrapper pt396_radio_block pt_396_active_block"><span class="pt396_subscription_radio_heading_wrapper"><span class="pt396_subscription_radio_heading pt396_radio_heading">Subscribe and Save 10%</span><span class="pt396_subscription_radio_real_price"></span><span class="pt396_subscription_radio_cut_price"></span></span><p class="pt396_subscription_guarantee_text">Pause & cancel anytime</p><p class="pt396_subscription_time_text">Delivery every 30 Days</p></div></div><div class="pt_416_onetime_wrapper pt_416_hidden"><div class="pt_416_onetime_left_container"><div class="pt_416_onetime_top_section"><div class="pt_416_onetime_left_top_wrapper"><p class="pt_416_onetime_left_heading">One-time purchase</p></div><div class="pt_416_toggle_switch pt_416_toggle_input_one_time"><label for="toggleSwitchSub" class="pt_416_toggle_label"></label></div></div><div class="pt_416_lower_data_wrapper"><div class="pt_416_lower_left_wrapper"><p class="pt_416_onetime_left_saving_copy">Want to save 10%?</p><p class="pt_416_onetime_left_lower_cta">Switch to Subscription!</p></div><div class="pt_416_lower_right_wrapper"><p class="pt_416_onetime_left_price">$68</p><p class="pt_432_cost_per_serving"></p></div></div></div></div><div class="pt_416_subscription_wrapper"><div class="pt_416_subscription_left_container"><div class="pt_416_subscription_top_section"><div class="pt_416_subscription_left_top_wrapper"><p class="pt_416_subscription_left_heading">Subscribe &amp; save 10%</p></div><div class="pt_416_toggle_switch pt_416_toggle_input_subscription"><label for="toggleSwitchSub" class="pt_416_toggle_label"></label></div></div><div class="pt_416_subscription_lower_text_wrapper"><div class="pt_416_left_lower_section"><p class="pt_416_subscription_lower_text">Lock in your discount <span class="pt_416_inner_span_points">for life</span></p><p class="pt_416_subscription_lower_text">Delivery every 30 days</p><p class="pt_416_subscription_lower_text">Try It Risk-Free For 90 Days</p></div><div class="pt_416_left_lower_section"><p class="pt_413_subscription_left_price"><span class="pt_413_subscription_left_green_price"></span> <span class="pt_413_subscription_left_normal_price Price Price--compareAt"></span><span class="pt_432_cost_per_serving_sub hidden-tablet-and-up"></span></p></div></div></div></div><button class=\'pt396_addToCart_button\'>ADD TO CART<span class="pt396_addToCart_button_separator"></span><span class="pt396_addToCart_button_price">$68</span></button><div class=\'pt396_productAccordian\'><button class="pt396_ingredient_accordian_button" aria-expanded="false">Ingredients<span class="pt396_ingredient_accordian_plus_icon"></span></button><div class="pt396_ingredient_accordian_dropdown_content"></div></div><a class=\'pt396_productDescription\'>View Full Product</a></div></div>',
            loader: '<div id="pt_396_loader_popin" class="pt_396_loader pt_396_hidden"><div class="spinner"></div></div>'
        };
    r(2), r(6);

    function c() {
        $(".pt396_popupWrapper .pt396_popupContainer .pt396_imageContainer > div").flickity({
            cellAlign: "left",
            contain: !0,
            autoPlay: !1,
            wrapAround: !0,
            prevNextButtons: !0,
            pageDots: !0
        })
    }
    var p = function() {
        ! function(t, e) {
            if (document.querySelector('script[src="'.concat(t, '"]'))) e && e();
            else {
                var r = document.createElement("script");
                r.src = t, r.onload = e, document.body.appendChild(r)
            }
        }("https://cdnjs.cloudflare.com/ajax/libs/flickity/2.2.2/flickity.pkgd.min.js", c)
    };

    function a() {
        document.querySelector(".pt396_popupContainer .pt396_popup").remove(), document.body.classList.remove("pt396_popupActive")
    }

    function u(t) {
        var e = t.target.getAttribute("data-var_id"),
            r = document.querySelector(".CollectionMain .ProductItem .ProductItem_AddToCartBtn button[data-var_id='".concat(e, "']"));
        if (t.target.closest(".pt396_popup").querySelector(".pt_396_subscriptionOption_not_available")) r.click(), a();
        else {
            var o = t.target.closest(".pt396_popup").querySelector(".pt396_subscription_wrapper").querySelector(".pt_396_active_block");
            o && n((function() {
                return r.closest(".ProductItem").querySelectorAll(".PT242__OptionWidget--Options").length > 0
            }), 5e4).then((function() {
                var t = r.closest(".ProductItem").querySelector(".PT242__OptionWidget--Options");
                if (o.classList.contains("pt396_subscription_radio_wrapper")) {
                    var e = t.querySelector(".PT242__OptionWidget--Subscription");
                    e && e.click()
                } else if (o.classList.contains("pt396_one_time_radio_wrapper")) {
                    var n = t.querySelector(".PT242__OptionWidget--Onetime");
                    n && n.click()
                }
                setTimeout((function() {
                    var t = null !== document.querySelector(".pt396_popupContainer .pt396_subscription_radio_wrapper.pt_396_active_block") && null !== document.querySelector(".PT242__OptionWidget--Subscription.PT242__OptionWidget--Active"),
                        e = null !== document.querySelector(".pt396_popupContainer .pt396_one_time_radio_wrapper.pt_396_active_block") && null !== document.querySelector(".PT242__OptionWidget--Onetime.PT242__OptionWidget--Active");
                    (t || e) && (r.closest(".ProductItem").querySelector("button.PT242__OptionWidget--Button").click(), a())
                }), 50)
            }))
        }
    }

    function d(t, e, r, n) {
        if (e.classList.remove("pt_396_active_block"), r.classList.remove("pt_396_active_block"), t.currentTarget.classList.add("pt_396_active_block"), t.currentTarget === r) {
            var o = r.querySelector(".pt396_subscription_radio_real_price");
            o && (n.textContent = o.textContent)
        } else if (t.currentTarget === e) {
            var i = e.querySelector(".pt396_one_time_real_price");
            i && (n.textContent = i.textContent)
        }
    }

    function _(t) {
        n((function() {
            return null !== t.querySelector(".ProductItem .ProductItem_AddToCartBtn .Button--secondary").getAttribute("data-var_id")
        }), 5e4).then((function() {
            var e, r, c = function(t) {
                    return {
                        productLink: t.querySelector(".ProductItem__Wrapper > a").href,
                        productName: t.querySelector("h2.ProductItem__Title.Heading").textContent.trim(),
                        productPrice: t.querySelector(".ProductItem__PriceList.Heading").innerHTML,
                        productId: t.querySelector(".ProductItem .ProductItem_AddToCartBtn .Button--secondary").getAttribute("data-var_id")
                    }
                }(t),
                a = c.productLink,
                _ = c.productName,
                l = c.productId;
            t.classList.add("pt_396_disable_link"), e = "section.Product", r = function(e) {
                var r = e.querySelector(o.productWrapperRating).outerHTML,
                    c = e.querySelector(".ProductMeta__Tags").outerHTML,
                    s = e.querySelector(".Collapsible.IngrediantTab .Collapsible__Inner .Collapsible__Content .HowToDrink_Tab"),
                    v = s ? s.innerHTML : "",
                    m = function(t, e) {
                        var r = t.querySelectorAll(o.productGalleryCarouselImage),
                            n = document.createElement("div");
                        if (r.forEach((function(t) {
                                n.insertAdjacentElement("beforeend", t.cloneNode())
                            })), "48598486214" === e) {
                            var i = n.querySelectorAll("img");
                            i.length > 0 && (i[0].src = "https://www.piquelife.com/cdn/shop/products/eGiftCard_A_1copy_400x.jpg?v=1644891854", i[0].alt = "Hardcoded Product Image 1"), i.length > 1 && (i[1].src = "https://www.piquelife.com/cdn/shop/products/eGiftCard_FAFAFA_1200x.jpg?v=1644893316", i[1].alt = "Hardcoded Product Image 2")
                        }
                        return n
                    }(e, l);
                !function(t) {
                    var e = t.ele,
                        r = t.productName,
                        o = t.productReview,
                        c = t.productBenefits,
                        p = t.productLink,
                        a = t.imageWrapper,
                        _ = t.productId,
                        l = t.ingredientAccrodian,
                        s = document.createElement("div");
                    s.classList.add("pt396_product_popupWrapper"), s.innerHTML = i.productPopup, e.insertAdjacentElement("beforeend", s), s.querySelector(".pt396_productName").innerHTML = r, s.querySelector(".pt396_reviewSection").innerHTML = o, s.querySelector(".pt396_productBenefitsContainer").innerHTML = c, s.querySelector("a.pt396_productDescription").setAttribute("href", p), s.querySelector(".pt396_ingredient_accordian_dropdown_content").innerHTML = l, s.querySelector(".pt396_imageContainer").insertAdjacentElement("afterbegin", a), s.querySelector(".pt396_addToCart_button").setAttribute("data-var_id", _), n((function() {
                        return null != e.querySelector(".PT242__OptionWidget")
                    }), 5e4).then((function() {
                       var w=document.querySelector(".pt396_popupWrapper"),h=(p||"").split("/").filter(Boolean).pop();h&&w&&w.classList.add(h);
                        var t = e.querySelector(".PT242__OptionWidget--Onetime span.PT242__OptionWidget--Price").textContent.trim(),
                            subscriptionLabelEl = e.querySelector(".PT242__OptionWidget--Subscription"),
                            hasSubscription = subscriptionLabelEl,
                            r = e.querySelector(".PT242__OptionWidget--Subscription span.PT242__OptionWidget--Label").textContent.trim(),
                            n = e.querySelector(".PT242__OptionWidget--Subscription span.PT242__OptionWidget--Price").textContent.trim();
                            var v = e.querySelector(".pt_413_onetime_wrapper span.pt_432_cost_per_serving").textContent.trim();
                        var u = e.querySelector(".PT242__OptionWidget--Subscription--Info span.pt_432_cost_per_serving_sub").textContent.trim();
                        if(hasSubscription)s.classList.add("not-subscription");
                        if (s.querySelector("span.pt396_one_time_real_price").textContent = t, s.querySelector("span.pt396_subscription_radio_heading").textContent = r, s.querySelector(".pt_432_cost_per_serving").textContent = v, s.querySelector(".pt_432_cost_per_serving_sub").textContent = u, s.querySelector("span.pt396_subscription_radio_real_price").textContent = n, s.querySelector("span.pt396_subscription_radio_cut_price").textContent = t, s.querySelector("span.pt396_addToCart_button_price").textContent = n, s.querySelector(".pt396_subscription_wrapper").classList.remove("pt_396_hide", "pt_396_subscriptionOption_not_available"), document.body.classList.contains("pt396_popupActive") && e.querySelector(".ProductItem__Title").textContent.trim().toLowerCase() === document.querySelector(".pt396_popupActive .pt396_popupContainer .pt396_productName").textContent.trim().toLowerCase()) {
                            var o = e.querySelector(".pt396_subscription_wrapper").cloneNode(!0),
                                i = e.querySelector("button.pt396_addToCart_button").cloneNode(!0),
                                c = document.querySelector(".pt396_popupActive .pt396_popupContainer"),
                                p = c.querySelector(".pt396_subscription_wrapper"),
                                a = c.querySelector("button.pt396_addToCart_button");
                            if (c && o && p && a) {
                                p.remove(), a.remove();
                                var _ = c.querySelector(".pt396_productBenefitsContainer");
                                _.insertAdjacentElement("afterend", i), _.insertAdjacentElement("afterend", o);
                                var l = c.querySelector(".pt396_subscription_wrapper"),
                                    v = l.querySelector(".pt396_one_time_radio_wrapper"),
                                    m = l.querySelector(".pt396_subscription_radio_wrapper"),
                                    f = c.querySelector("button.pt396_addToCart_button .pt396_addToCart_button_price");
                                v.addEventListener("click", (function(t) {
                                    return d(t, v, m, f)
                                })), m.addEventListener("click", (function(t) {
                                    return d(t, v, m, f)
                                })), c.querySelector(".pt396_addToCart_button").addEventListener("click", u)
                            }
                        }
                    })), e.classList.remove("pt_396_disable_link")
                }({
                    ele: t,
                    productName: _,
                    productReview: r,
                    productBenefits: c,
                    productLink: a,
                    imageWrapper: m,
                    productId: l,
                    ingredientAccrodian: v
                }),
                function(t) {
                    t.querySelectorAll("a[href]").forEach((function(t) {
                      var clickedProductEl = t.closest(".ProductItem");
                        t.addEventListener("click", (function(t) {
                            t.preventDefault(),
                                function(t) {
                                    var e = document.querySelector(".pt396_popupContainer");
                                    if (t && e) {
                                        e.insertAdjacentElement("beforeend", t), e.querySelector(".pt396_imageContainer > div") && setTimeout(p, 100), e.querySelector(".pt396_addToCart_button").addEventListener("click", u);
                                        var r = e.querySelector(".pt396_ingredient_accordian_button"),
                                            n = e.querySelector(".pt396_ingredient_accordian_dropdown_content");
                                        r.addEventListener("click", (function() {
                                            var t = "true" === r.getAttribute("aria-expanded");
                                            r.setAttribute("aria-expanded", !t), n.classList.toggle("pt_396_drop_active")
                                        }));
                                        var o = e.querySelector(".pt396_subscription_wrapper"),
                                            i = o.querySelector(".pt396_one_time_radio_wrapper"),
                                            c = o.querySelector(".pt396_subscription_radio_wrapper"),
                                            a = e.querySelector("button.pt396_addToCart_button .pt396_addToCart_button_price");
                                        i.addEventListener("click", (function(t) {
                                           clickedProductEl.querySelector(".PT242__OptionWidget .PT242__OptionWidget--Onetime").classList.add('PT242__OptionWidget--Active');
                                          clickedProductEl.querySelector(".PT242__OptionWidget .PT242__OptionWidget--Subscription").classList.remove('PT242__OptionWidget--Active');
                                            return d(t, i, c, a)
                                        })), c.addEventListener("click", (function(t) {
                                           clickedProductEl.querySelector(".PT242__OptionWidget .PT242__OptionWidget--Onetime").classList.remove('PT242__OptionWidget--Active');
                                          clickedProductEl.querySelector(".PT242__OptionWidget .PT242__OptionWidget--Subscription").classList.add('PT242__OptionWidget--Active');
                                            return d(t, i, c, a)
                                        }));
                                        var _ = e.querySelector(".pt396_productAccordian"),
                                            l = e.querySelector(".pt396_ingredient_accordian_dropdown_content");
                                        l && "" !== l.innerHTML.trim() || _.classList.add("pt_396_no_content_ingredient_hidden")
                                    }
                                    document.body.classList.contains("pt396_popupActive") || document.body.classList.add("pt396_popupActive");
                                     setupPT416ToggleSwitches(document.querySelector('.pt396_popupContainer'));
                                    var popupWrapper = document.querySelector(".pt396_popupWrapper");
                                    const oneTimePrice = clickedProductEl.querySelector('.ProductItem__PriceList .ProductItem__Price');
                                    if(clickedProductEl.querySelector('.PT242__OptionWidget--Subscription span.PT242__OptionWidget--Price') == null ){
                                      popupWrapper.querySelector('.pt396_addToCart_button .pt396_addToCart_button_price').textContent = oneTimePrice.textContent;
                                    };
                                    const classList = Array.from(clickedProductEl.classList);
                                    const handle = classList.find(cls => cls !== "ProductItem");
                                     if (popupWrapper && handle) {
                                        popupWrapper.className = popupWrapper.className
                                        .split(" ")
                                        .filter(cls => !cls.startsWith("pt396-handle-"))
                                        .join(" ");
                                      // Add current handle
                                      popupWrapper.classList.add(`pt396-handle-${handle}`);
                                     }
                                }(t.target.closest(".ProductItem").querySelector(".pt396_popup").cloneNode(!0))
                        }))
                    }))
                }(t)
            }, fetch(a).then((function(t) {
                return t.text()
            })).then((function(t) {
                var n = (new DOMParser).parseFromString(t, "text/html");
                try {
                    var o = n.querySelector(e);
                    r(o)
                } catch (t) {
                    r(null, t)
                }
            })).catch((function(t) {
                console.warn("Something went wrong.", t)
            }))
        }))
    }! function(t, e) {
        ! function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "v1";
            window.optiActiveTests = window.optiActiveTests || {}, window.optiActiveTests[t] = e
        }("PT_396", "v1");
        var r = function(t, e) {
            return t ? console.log.bind(console, "".concat(e, ":")) : function() {}
        }(!1, "PT_396");
        n((function() {
            return null != document.querySelector(o.subCollections) && window.location.href.includes("collections/") && "function" == typeof window.jQuery
        })).then((function() {
            var t, e;
            r("workflow fn called"), window.innerWidth > 767 || ("function" != typeof window.optiReady && function() {
                var t, e = [],
                    r = window.document,
                    n = window.MutationObserver || window.WebKitMutationObserver;

                function o() {
                    for (var t, n, o = 0, i = e.length; o < i; o++) {
                        t = e[o];
                        for (var c, p = 0, a = (n = r.querySelectorAll(t.selector)).length; p < a; p++)(c = n[p]).ready || (c.ready = []), c.ready[o] || (c.ready[o] = !0, t.fn.call(c, c))
                    }
                }
                window.optiReady = function(i, c) {
                    e.push({
                        selector: i,
                        fn: c
                    }), t || (t = new n(o)).observe(r.documentElement, {
                        childList: !0,
                        subtree: !0
                    }), o()
                }
            }(), document.body.classList.add("pt_396"), document.querySelector(".pt396_popupWrapper") || document.body.insertAdjacentHTML("beforeend", i.productPopupWrapper), t = document.querySelector(".pt396_popupOverlay"), e = document.querySelector(".pt396_popupWrapper .pt396_closePopup_btn"), t.addEventListener("click", (function() {
                a()
            })), e.addEventListener("click", (function() {
                a()
            })), window.optiReady(o.productItem, (function(t) {
                _(t)

            })))
        }))
    }()
}, function(t, e) {}, , , , function(t, e) {}]);